import { render, staticRenderFns } from "./GoodsRewardForm.vue?vue&type=template&id=774d2638&scoped=true&"
import script from "./GoodsRewardForm.vue?vue&type=script&lang=js&"
export * from "./GoodsRewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d2638",
  null
  
)

export default component.exports